export const MILLISECONDS_BY_TIME_UNIT: { [key: string]: number } = {
  MONTH: 2629800000,
  m: 2629800000,
  WEEK: 604800000,
  w: 604800000,
};

export const MONTHS_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MONTH_HISTORIC_RAW = [
  { month: "3", year: "2024" },
  { month: "4", year: "2024" },
  { month: "0", year: "2026" },
  { month: "1", year: "2026" },
  { month: "2", year: "2026" },
  { month: "3", year: "2026" },
  { month: "4", year: "2026" },
  { month: "5", year: "2026" },
  { month: "6", year: "2026" },
  { month: "7", year: "2026" },
  { month: "8", year: "2026" },
  { month: "9", year: "2026" },
  { month: "10", year: "2026" },
  { month: "11", year: "2026" },
];

const buildMonthHistoricOptions = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  return MONTH_HISTORIC_RAW.map((entry) => {
    const year = Number(entry.year);
    const month = Number(entry.month);
    const isPast = year < currentYear || (year === currentYear && month < currentMonth);
    return {
      label: `${MONTHS_NAMES[month]}-${entry.year}`,
      month: entry.month,
      disabled: !isPast,
      year: entry.year,
    };
  });
};

export const MONTH_HISTORIC_OPTIONS = buildMonthHistoricOptions();
